module.exports = __webpack_public_path__ + "img/coverLogo6.4de9cd90.jpg";